// Test IDs for the Seguimiento y recurrencia de tratamientos feature.

export const FOLLOWUPS = {
  page: 'followups-page',
  bucketTabAll: 'followups-bucket-tab-all',
  bucketTabUpcoming: 'followups-bucket-tab-upcoming',
  bucketTabOverdue: 'followups-bucket-tab-overdue',
  bucketTabAtRisk: 'followups-bucket-tab-at_risk',
  contactStatusSelect: 'followups-contact-status-select',
  serviceFilterSelect: 'followups-service-filter-select',
  professionalFilterSelect: 'followups-professional-filter-select',
  searchInput: 'followups-search-input',
  list: 'followups-list',
  rowPrefix: 'followups-row-', // + treatmentId
  emptyState: 'followups-empty-state',
  viewProfileButtonPrefix: 'followups-view-profile-button-', // + treatmentId
  contactButtonPrefix: 'followups-contact-button-', // + treatmentId
  whatsappButtonPrefix: 'followups-whatsapp-button-', // + treatmentId
  postponeButtonPrefix: 'followups-postpone-button-', // + treatmentId
  discardButtonPrefix: 'followups-discard-button-', // + treatmentId
  reactivateButtonPrefix: 'followups-reactivate-button-', // + treatmentId
  historyButtonPrefix: 'followups-history-button-', // + treatmentId

  actionModal: 'followups-action-modal',
  actionNotesInput: 'followups-action-notes-input',
  actionDateInput: 'followups-action-date-input',
  actionSaveButton: 'followups-action-save-button',
  actionCancelButton: 'followups-action-cancel-button',

  whatsappModal: 'followups-whatsapp-modal',
  whatsappPhoneInput: 'followups-whatsapp-phone-input',
  whatsappMessageInput: 'followups-whatsapp-message-input',
  whatsappSendButton: 'followups-whatsapp-send-button',
  whatsappCancelButton: 'followups-whatsapp-cancel-button',

  historyModal: 'followups-history-modal',
  historyEmptyState: 'followups-history-empty-state',
  historyItemPrefix: 'followups-history-item-',

  dashboardCard: 'followup-dashboard-card',
  dashboardCardAmount: 'followup-dashboard-card-amount',
  dashboardCardCount: 'followup-dashboard-card-count',
  dashboardCardCriterion: 'followup-dashboard-card-criterion',

  // Estado de seguimiento en la ficha del paciente (tab Tratamientos).
  patientBadgePrefix: 'patient-followup-badge-', // + treatmentId
  patientContactButtonPrefix: 'patient-followup-contact-button-',
  patientPostponeButtonPrefix: 'patient-followup-postpone-button-',
  patientDiscardButtonPrefix: 'patient-followup-discard-button-',
  patientReactivateButtonPrefix: 'patient-followup-reactivate-button-',

  // Duración del efecto en el modal de Servicios.
  serviceEffectDurationValueInput: 'services-modal-effect-duration-value-input',
  serviceEffectDurationUnitSelect: 'services-modal-effect-duration-unit-select',
};
